export const dashboardPageStyles = {
  page: {
    minHeight: '100%',
    padding: '14px 0 22px',
    background: 'linear-gradient(180deg, #f6f8ff 0%, #f8fbff 42%, #ffffff 100%)',
  } as const,
  loadingPage: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  } as const,
  topBar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 12,
    padding: '0 16px 10px',
  } as const,
  brandRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    minWidth: 0,
  } as const,
  brandMark: {
    width: 38,
    height: 38,
    borderRadius: 10,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#111827',
    color: '#ffffff',
    fontSize: 13,
    fontWeight: 900,
  } as const,
  brandTitle: {
    fontSize: 18,
    lineHeight: 1.1,
    fontWeight: 900,
    color: '#111827',
  } as const,
  brandSubtitle: {
    marginTop: 2,
    fontSize: 11,
    lineHeight: 1.25,
    color: '#7b8497',
    fontWeight: 650,
  } as const,
  hero: {
    margin: '0 16px',
    borderRadius: 28,
    padding: '22px 18px 20px',
    background: '#ffffff',
    boxShadow: '0 16px 34px rgba(31, 41, 55, 0.08)',
    border: '1px solid rgba(93, 102, 245, 0.10)',
    overflow: 'hidden',
  } as const,
  heroEyebrow: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 8,
    padding: '7px 10px',
    borderRadius: 999,
    background: '#eef7f1',
    color: '#127045',
    fontSize: 12,
    lineHeight: 1,
    fontWeight: 800,
  } as const,
  heroTitle: {
    marginTop: 16,
    fontSize: 28,
    lineHeight: 1.16,
    fontWeight: 900,
    color: '#151a27',
    letterSpacing: 0,
  } as const,
  heroText: {
    marginTop: 10,
    fontSize: 14,
    lineHeight: 1.65,
    color: '#5e6678',
    fontWeight: 550,
  } as const,
  heroActions: {
    marginTop: 18,
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: 10,
    alignItems: 'stretch',
  } as const,
  primaryButton: {
    minHeight: 52,
    borderRadius: 12,
    fontWeight: 800,
    fontSize: 14,
    lineHeight: 1.2,
    whiteSpace: 'normal',
    padding: '0 10px',
    '--background-color': '#1769ff',
    '--border-color': '#1769ff',
  } as const,
  secondaryButton: {
    minHeight: 52,
    borderRadius: 12,
    fontWeight: 800,
    fontSize: 14,
    lineHeight: 1.2,
    whiteSpace: 'normal',
    padding: '0 10px',
    '--border-color': '#d6ddec',
    '--text-color': '#1f2937',
  } as const,
  section: {
    margin: '16px 16px 0',
  } as const,
  sectionTitle: {
    fontSize: 18,
    lineHeight: 1.25,
    fontWeight: 900,
    color: '#151a27',
  } as const,
  sectionText: {
    marginTop: 5,
    fontSize: 13,
    lineHeight: 1.55,
    color: '#7a8395',
    fontWeight: 550,
  } as const,
  methodGrid: {
    marginTop: 12,
    display: 'grid',
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    gap: 10,
    alignItems: 'stretch',
  } as const,
  methodCard: {
    minWidth: 0,
    borderRadius: 18,
    padding: 12,
    background: '#ffffff',
    border: '1px solid rgba(93, 102, 245, 0.10)',
    boxShadow: '0 10px 22px rgba(31, 41, 55, 0.055)',
    display: 'flex',
    flexDirection: 'column',
  } as const,
  methodHead: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: 8,
  } as const,
  methodIcon: {
    width: 34,
    height: 34,
    borderRadius: 10,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#1769ff',
    background: '#eef4ff',
    fontSize: 18,
    flexShrink: 0,
  } as const,
  methodBadge: {
    padding: '4px 7px',
    borderRadius: 999,
    background: '#ecfdf3',
    color: '#067647',
    fontSize: 10,
    lineHeight: 1,
    fontWeight: 850,
    whiteSpace: 'nowrap',
  } as const,
  methodTitle: {
    marginTop: 10,
    fontSize: 14,
    lineHeight: 1.3,
    fontWeight: 900,
    color: '#151a27',
  } as const,
  methodDesc: {
    marginTop: 5,
    fontSize: 12,
    lineHeight: 1.45,
    color: '#646d80',
    fontWeight: 550,
  } as const,
  methodButton: {
    marginTop: 'auto',
    minHeight: 44,
    borderRadius: 12,
    fontWeight: 800,
    fontSize: 13,
    lineHeight: 1.2,
    whiteSpace: 'normal',
    padding: '0 8px',
  } as const,
  notice: {
    marginTop: 12,
    borderRadius: 18,
    padding: '13px 14px',
    background: '#fff7e6',
    border: '1px solid #ffe0a3',
    color: '#7a5205',
    fontSize: 13,
    lineHeight: 1.55,
    fontWeight: 750,
  } as const,
  flowCard: {
    marginTop: 12,
    borderRadius: 24,
    padding: '8px 14px 14px',
    background: '#ffffff',
    border: '1px solid rgba(93, 102, 245, 0.10)',
    boxShadow: '0 12px 26px rgba(31, 41, 55, 0.06)',
  } as const,
  flowItem: {
    display: 'grid',
    gridTemplateColumns: '34px 1fr',
    gap: 10,
    padding: '14px 0',
    borderBottom: '1px solid #eef1f6',
  } as const,
  flowItemLast: {
    borderBottom: 'none',
  } as const,
  flowIndex: {
    width: 30,
    height: 30,
    borderRadius: 10,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#eef4ff',
    color: '#1769ff',
    fontSize: 12,
    fontWeight: 900,
  } as const,
  flowTitle: {
    fontSize: 14,
    lineHeight: 1.35,
    fontWeight: 900,
    color: '#151a27',
  } as const,
  flowDesc: {
    marginTop: 4,
    fontSize: 12,
    lineHeight: 1.55,
    color: '#687386',
    fontWeight: 550,
  } as const,
  redemptionCard: {
    marginTop: 12,
    borderRadius: 22,
    padding: 16,
    background: '#f5f7ff',
    border: '1px solid rgba(93, 102, 245, 0.14)',
  } as const,
  redemptionTitle: {
    fontSize: 15,
    lineHeight: 1.35,
    fontWeight: 900,
    color: '#151a27',
  } as const,
  redemptionText: {
    marginTop: 8,
    fontSize: 13,
    lineHeight: 1.6,
    color: '#5e6678',
    fontWeight: 550,
  } as const,
  faqList: {
    marginTop: 12,
    display: 'grid',
    gap: 10,
  } as const,
  faqItem: {
    borderRadius: 18,
    padding: 14,
    background: '#ffffff',
    border: '1px solid #eef1f6',
  } as const,
  faqQuestion: {
    fontSize: 13,
    lineHeight: 1.35,
    fontWeight: 900,
    color: '#151a27',
  } as const,
  faqAnswer: {
    marginTop: 6,
    fontSize: 12,
    lineHeight: 1.55,
    color: '#687386',
    fontWeight: 550,
  } as const,
};
